import React, { ReactElement, memo, useEffect, useState } from 'react'
import ErrorTypography from './ErrorTypography'
import Progress from './Progress'
import { RetrievableProps } from './Retrievable.types'

function Retrievable<T>({
    getPromise,
    setData,
    builder,
}: RetrievableProps<T>): ReactElement {
    const [status, setStatus] = useState<'loading' | 'loaded' | Error>(
        'loading'
    )

    useEffect(() => {
        setStatus('loading')
        getPromise()
            .then((t) => {
                setData(t)
                setStatus('loaded')
            })
            .catch((error) => {
                setStatus(error)
            })
        // eslint-disable-next-line
    }, [getPromise])

    if (status === 'loaded') {
        return builder()
    }

    if (status instanceof Error) {
        return <ErrorTypography text={status.message} />
    }

    return <Progress />
}

export default memo(Retrievable)
